import { REVENUE_THRESHOLD } from "./thresholds";
import { formatPhone, isValidEmail, isValidInn, isValidPhone, isValidUrl, } from "../../../utils";
export const validateProfileProps = (values) => {
    return {
        ...values,
        user_inn: isValidInn(values.user_inn) ? values.user_inn : null,
        user_phone: isValidPhone(values.user_phone) ? formatPhone(values.user_phone) : null,
        user_mail: isValidEmail(values.user_mail) ? values.user_mail : null,
        user_site: isValidUrl(values.user_site) ? values.user_site : null,
    };
};
export const validateRequestValues = (values, defaultParams) => {
    let result = { ...values };
    result = {
        ...validateProfileProps(result),
        swot: {
            opportunity_list: result.swot.opportunity_list?.filter(Boolean) ?? [],
            strength_list: result.swot.strength_list?.filter(Boolean) ?? [],
            threat_list: result.swot.threat_list?.filter(Boolean) ?? [],
            weakness_list: result.swot.weakness_list?.filter(Boolean) ?? [],
        },
        difference_list: result.difference_list?.filter(Boolean) ?? [],
        strategy_list: result.strategy_list?.filter(Boolean) ?? [],
        assortment1_list: result.assortment1_list?.filter(Boolean) ?? [],
        assortment2_list: result.assortment2_list?.filter(Boolean) ?? [],
        product_list: result.product_list?.reduce((acc, curr) => {
            return Boolean(curr.name) && Boolean(curr.price) ? [...acc, curr] : acc;
        }, []) ?? [],
        channel_list: result.channel_list?.filter(Boolean) ?? [],
        credit_bank: result.credit_bank === -1 ? null : result.credit_bank,
        credit_other: result.credit_bank !== -1 ? null : result.credit_other,
    };
    if (defaultParams !== undefined) {
        const totalRevenue = values.use_count * values.day_count * values.avg_check;
        if (totalRevenue > REVENUE_THRESHOLD) {
            result = {
                ...result,
                use_count: defaultParams.use_count.value,
                avg_check: defaultParams.avg_check.value,
                day_count: defaultParams.day_count.value,
            };
        }
    }
    return result;
};
